import { Component, Input } from "@angular/core";
import { ErrorComponentBase } from "../error.decorator";
import { IMenu } from "app/types/menu";

export interface Error404PageComponent extends ErrorComponentBase { }
@Component({
    selector: "error-404-page-component",
    templateUrl: "../error.view.html",
    standalone: false
})
@ErrorComponentBase
export class Error404PageComponent {

  @Input() error: { [key: string]: any };
  @Input() home: IMenu = null;
  @Input() sections: IMenu[] = [];

  code: string = '404';
  subTitle: string = "Page Not Found";
  lead: string = `We are sorry, but the page you requested was not found.`

}
